import loadable from '@loadable/component';

// 懒加载组件
const DeliveryQuery = loadable(() => import('./deliveryQuery/DeliveryQuery'));
const DeliveryModify = loadable(() => import('./deliveryQuery/deliveryModify/DeliveryModify'));
const NcrmImplantationOrderManagement = loadable(() => import('./ncrmImplantationOrderManagement/NcrmImplantationOrderManagement'));
const OrderManagement = loadable(() => import('./orderManagement/OrderManagement'));
const DeliveryOrder = loadable(() => import('./ncrmImplantationOrderManagement/deliveryOrder/DeliveryOrder'));
const NcrmImplantationBoxQuery = loadable(() => import('./ncrmImplantationBoxQuery/NcrmImplantationBoxQuery'));
const ncrmStockupDeliveryQuery = loadable(() => import('./ncrmStockupDeliveryQuery/ncrmStockupDeliveryQuery'));
const ncrmStockupDeliveryModify = loadable(() => import('./ncrmStockupDeliveryQuery/stockupDeliveryModify/ncrmStockupDeliveryModify'));
const NcrmImplantationRequestManagement = loadable(() => import('./ncrmImplantationRequestManagement/NcrmImplantationRequestManagement'));
const ImplantationRequestItem = loadable(() => import('./ncrmImplantationRequestManagement/implantationRequestItem/ImplantationRequestItem.js'));
const DeliveryDetailQuery = loadable(() => import('./deliveryDetailQuery/DeliveryDetailQuery'));
const HospitalInventoryDetailQuery = loadable(() => import('./hospitalInventoryDetailQuery/HospitalInventoryDetailQuery'));
const HosItemPriceQuery = loadable(() => import('./hosItemPriceQuery/HosItemPriceQuery'));

export const subRoutes = [
  { // 【南川人民】供应商：植入耗材订单响应
    path: '/NcrmImplantationOrderManagement',
    component: NcrmImplantationOrderManagement
  },
  { // 【南川人民】供应商：植入耗材套包查询
    path: '/NcrmImplantationBoxQuery',
    component: NcrmImplantationBoxQuery
  },
  { // 订单查询响应 (南川定制化)
    path: '/OrderManagement',
    component: OrderManagement
  },
  { // 订单查询响应 (南川定制化)  发货单页面
    path: '/DeliveryOrder',
    component: DeliveryOrder
  },
  { // 253002: 耗材发货单查询(南川定制化)
    path: '/DeliveryQuery',
    component: DeliveryQuery
  },
  { // 242302: 耗材发货单查询 --- 发货单修改 (南川定制化)
    path: '/DeliveryModify',
    component: DeliveryModify
  },
  { // 253002: 耗材发货单查询(南川定制化)
    path: '/ncrmStockupDeliveryQuery',
    component: ncrmStockupDeliveryQuery
  },
  { // 242302: 耗材发货单查询 --- 发货单修改 (南川定制化)
    path: '/ncrmStockupDeliveryModify',
    component: ncrmStockupDeliveryModify
  },
  { // 809253501: 植入耗材申请管理 (南川定制化)
    path: '/NcrmImplantationRequestManagement',
    component: NcrmImplantationRequestManagement
  },
  { // 809253501: 植入耗材申请管理 --- 明细(南川定制化)
    path: '/ImplantationRequestItem',
    component: ImplantationRequestItem
  },
  { // 809253005: 发货明细查询 (南川定制化)
    path: '/DeliveryDetailQuery',
    component: DeliveryDetailQuery
  },
  { // M809251022 供应商：医院库存查询明细 (南川定制化)
    path: '/HospitalInventoryDetailQuery',
    component: HospitalInventoryDetailQuery
  },
  { // M809251010 供应商：正在供应耗材查询
    path: '/HosItemPriceQuery',
    component: HosItemPriceQuery
  }
];
